import SmoothScroll from 'smooth-scroll'

/**
 * VisitUs
 * @author Dayne Coulson-Hoffacker
 */
export default class VisitUs {
  /**
   * Constructs a new VisitUs instance.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    this.bookNowBtn = this.element.querySelector('[data-component="book-now-scroll-btn"]')
    this.scrollTarget = document.querySelector('.visit-us-block-6')
    this.options = {
      speed: 500,
      speedAsDuration: true,
      easing: 'easeInOutQuart',
      offset: 0,
      header: '[data-component="global-header"]'
    }
    var scroll = new SmoothScroll()

    if (this.bookNowBtn) {
      this.bookNowBtn.addEventListener('click', () => {
        scroll.animateScroll(this.scrollTarget, this.scrollToReviewsBtn, this.options)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./components/section/visit-us-blocks/index.js